export enum AccessDateTypes {
  GRANT = 'GRANT',
  REVOKE = 'REVOKE',
}
